import { IBillingDashboardActionPayload } from '../types';

export enum BillingActionType {
    GET_BILLING_DASHBOARD_DATA = 'GET_BILLING_DASHBOARD_DATA',
    ADD_CARD_TO_CUSTOMER = 'ADD_CARD_TO_CUSTOMER',
    CREATE_BILLING_CUSTOMER_DATA = 'CREATE_BILLING_CUSTOMER_DATA',
}

interface GetBillingActionType {
    type: BillingActionType.GET_BILLING_DASHBOARD_DATA;
    payload: IBillingDashboardActionPayload;
}

interface AddCardBillingActionType {
    type: BillingActionType.ADD_CARD_TO_CUSTOMER;
    payload: IBillingDashboardActionPayload;
}

interface CreateBillingCustomerDataActionType {
    type: BillingActionType.CREATE_BILLING_CUSTOMER_DATA;
    payload: IBillingDashboardActionPayload;
}

export type BillingAction =
    | GetBillingActionType
    | AddCardBillingActionType
    | CreateBillingCustomerDataActionType;
